import { z } from 'zod';
import { isConfigurableCapabilityRole, isRoleCapability } from '../types/capabilities.js';
/** One cell of the grid in Settings: may this role do this. */
export const setRoleCapabilitySchema = z.object({
    role: z.string().refine(isConfigurableCapabilityRole, 'That role is not set in this grid.'),
    capability: z.string().refine(isRoleCapability, 'Unknown capability.'),
    allowed: z.boolean(),
});
//# sourceMappingURL=capabilities.js.map